import {
  onCheckCondition,
  searchCondition,
} from 'designer/component/action/condition/Action'
import { checkWithDefaultValue } from './index'
import { crud } from './Crud'

export const onRowApiAdd = (newData, action, props) =>
  new Promise((resolve, reject) => {
    setTimeout(async () => {
      const {
        jsonForm,
        formData,
        uischema,
        designContext,
        renderTableData,
        allParams,
        user,
        onRowDefaultAction,
      } = props

      newData = checkWithDefaultValue(newData, uischema)
      let hasAddRowCondition = searchCondition(jsonForm, uischema.key, {
        stateKey: 'isAddRow',
      })
      let hasAfterAddRowCondition = searchCondition(jsonForm, uischema.key, {
        stateKey: 'isAfterAddRow',
      })
      if (!action.method) {
        action.method = 'post'
      }

      if (hasAddRowCondition.length > 0) {
        onCheckCondition(designContext, formData, uischema.key, {
          dataTable: [newData],
          rowData: [newData],
          isAddRow: true,
          isApiTable: true,
          filterCondition: hasAddRowCondition,
        })
      } else if (hasAfterAddRowCondition.length > 0) {
        await crud({
          action,
          rowData: newData,
          designContext,
          renderTableData,
          allParams,
          user,
          uischema,
        })
        onCheckCondition(designContext, formData, uischema.key, {
          isAddRow: true,
        })
      } else {
        await onRowDefaultAction(action, newData, true)
      }
      resolve()
    }, 1000)
  })

export const onRowApiUpdate = (newData, oldData, action, props) =>
  new Promise((resolve, reject) => {
    setTimeout(async () => {
      const {
        jsonForm,
        formData,
        uischema,
        designContext,
        renderTableData,
        allParams,
        user,
        onRowDefaultAction,
      } = props

      newData = checkWithDefaultValue(newData, uischema)
      let hasAddRowCondition = searchCondition(jsonForm, uischema.key, {
        stateKey: 'isEditRow',
      })
      let hasAfterAddRowCondition = searchCondition(jsonForm, uischema.key, {
        stateKey: 'isAfterEditRow',
      })
      if (!action.method) {
        action.method = 'put'
      }
      if (hasAddRowCondition.length > 0) {
        onCheckCondition(designContext, formData, uischema.key, {
          dataTable: [newData],
          rowData: [newData],
          isEditRow: true,
          isApiTable: true,
          filterCondition: hasAddRowCondition,
        })
      } else if (hasAfterAddRowCondition.length > 0) {
        await crud({
          action,
          rowData: newData,
          designContext,
          renderTableData,
          allParams,
          user,
          uischema,
        })
        onCheckCondition(designContext, formData, uischema.key, {
          isEditRow: true,
        })
      } else {
        await onRowDefaultAction(action, newData, true)
      }

      resolve()
    }, 1000)
  })

export const onRowApiDelete = (oldData, action, { onRowDefaultAction }) =>
  new Promise((resolve, reject) => {
    setTimeout(async () => {
      if (!action.action) {
        action.action = 'api'
      }
      if (!action.method) {
        action.method = 'delete'
      }
      await onRowDefaultAction(action, oldData, true)
      resolve()
    }, 1000)
  })
